import { PropsWithChildren } from 'react';

import { classNames } from '@/shared/lib/classNames/classNames';

type ChipWithLinearGradientSpacing = 'compact' | 'default';
type ChipWithLinearGradientRounded = '12' | '20';

const SPACING_CONFIG: Record<ChipWithLinearGradientSpacing, string> = {
  compact: 'px-5 py-3',
  default: 'px-6 py-4',
};

const ROUNDED_CONFIG: Record<ChipWithLinearGradientRounded, string> = {
  '12': 'rounded-[12px]',
  '20': 'rounded-[20px]',
};

interface ChipWithLinearGradientProps {
  className?: string;
  spacing?: ChipWithLinearGradientSpacing;
  rounded?: ChipWithLinearGradientRounded;
}

export const ChipWithLinearGradient = ({
  className,
  spacing = 'default',
  rounded = '20',
  children,
}: PropsWithChildren<ChipWithLinearGradientProps>) => {
  return (
    <div
      className={classNames({
        cls: `flex bg-gradient-to-r from-white/[0.06] to-transparent ${SPACING_CONFIG[spacing]} ${ROUNDED_CONFIG[rounded]}`,
        additional: [className],
      })}
    >
      {children}
    </div>
  );
};
